import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import LeadScanPage from "./pages/LeadScanPage";

// Components
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';

// Pages
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { PartiesPage } from './pages/PartiesPage';
import { PartyFormPage } from './pages/PartyFormPage';
import { ItemsPage } from './pages/ItemsPage';
import { ItemFormPage } from './pages/ItemFormPage';
import { LeadsPage } from './pages/LeadsPage';
import { LeadFormPage } from './pages/LeadFormPage';
import { QuotationsPage } from './pages/QuotationsPage';
import { QuotationFormPage } from './pages/QuotationFormPage';
import { ProformaInvoicesPage } from './pages/ProformaInvoicesPage';
import { ProformaInvoiceFormPage } from './pages/ProformaInvoiceFormPage';
import { SOAPage } from './pages/SOAPage';
import { SOAFormPage } from './pages/SOAFormPage';
import { SettingsPage } from './pages/SettingsPage';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/sunstore">
        <Routes>

          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Parties */}
          <Route
            path="/parties"
            element={
              <ProtectedRoute>
                <Layout>
                  <PartiesPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/parties/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <PartyFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/parties/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <PartyFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Items */}
          <Route
            path="/items"
            element={
              <ProtectedRoute>
                <Layout>
                  <ItemsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/items/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <ItemFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/items/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <ItemFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Leads */}
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                <Layout>
                  <LeadsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/leads/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <LeadFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/leads/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <LeadFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Quotations */}
          <Route
            path="/quotations"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuotationsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotations/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuotationFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotations/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuotationFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotations/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <QuotationFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Proforma Invoices */}
          <Route
            path="/proforma-invoices"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProformaInvoicesPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/proforma-invoices/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProformaInvoiceFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/proforma-invoices/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProformaInvoiceFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/proforma-invoices/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProformaInvoiceFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* SOA */}
          <Route
            path="/soa"
            element={
              <ProtectedRoute>
                <Layout>
                  <SOAPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/soa/new"
            element={
              <ProtectedRoute>
                <Layout>
                  <SOAFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/soa/:id"
            element={
              <ProtectedRoute>
                <Layout>
                  <SOAFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/soa/:id/edit"
            element={
              <ProtectedRoute>
                <Layout>
                  <SOAFormPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Settings */}
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <SettingsPage />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Default Routes */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
          <Route path="/leads/scan" element={<LeadScanPage />} />

        </Routes>
      </BrowserRouter>

      <Toaster position="top-center" richColors />

    </AuthProvider>
  );
}

export default App;